module.exports = __webpack_public_path__ + "img/UG.8af00062.png";